import LANG_1_ICON from "@amplio-common/assets/img/languages/1.png";
import LANG_2_ICON from "@amplio-common/assets/img/languages/2.png";
import LANG_3_ICON from "@amplio-common/assets/img/languages/3.png";
// Imports from date-fns should be with explicitly locale and be changed in webpack config!
import { es } from "date-fns/locale/es/index.js";
import { he } from "date-fns/locale";
import { enUS } from "date-fns/locale/en-US/index.js";

export const LanguageIds = {
  English: 1,
  Espanol: 3,
  Hebrew: 2,
};

export const Languages = [
  { label: "English", value: 1, locale: "en-US", icon: LANG_1_ICON, dateLocal: enUS, dateFormat: "MMMM d, yyyy 'at' hh:mm b" },
  { label: "Espa\u00F1ol", value: 3, locale: "es_DO", icon: LANG_3_ICON, dateLocal: es, dateFormat: "MMMM d, yyyy hh:mm b" },
  { label: "עברית", value: 2, locale: "he-IL", icon: LANG_2_ICON, dateLocal: he, dateFormat: "d MMMM yyy, HH:mm" },
];

// export const GetLanuageFromId = id => {
//   for (let index = 0; index < Languages.length; index++) {
//     const lanuage = Languages[index];
//     if (lanuage.value === id) {
//       return lanuage;
//     }
//   }
//   return Languages[0];
// };

export const GetLanuageFromId = id => Languages.find(item => item.value === id) || Languages[0];
